<app-reservation-view [isRecurring]="true"></app-reservation-view>
